import React from 'react'
import { Masonry } from "masonic";
import Prompt from './Prompt';

const Masonic = ({ prompts }) => {
    return (
        <Masonry items={prompts} columnGutter={5} columnWidth={400} overscanBy={5} render={MasonryCard} />
    )
  }

  const MasonryCard = ({ data: { postedBy, image, _id, type, favourite, status}}) => (
    <Prompt key={_id} prompt={{ postedBy, image, _id, type, favourite, status}} className='w-max' />
  );

export default Masonic